export default function Credit(props) {
  return (
    <svg width='20.35' height='14.536' viewBox='0 0 20.35 14.536' fill='#a5a8b9' {...props}>
      <path
        id='f135'
        d='M20.35.7V2.746H0V.7Q0,0,.754,0h18.9A.619.619,0,0,1,20.35.7ZM0,13.836V5.491H20.35v8.345a.619.619,0,0,1-.7.7H.754Q0,14.536,0,13.836Z'
      />
    </svg>
  )
}
